import React, { useEffect, useState } from "react";
import api, { formatINR } from "../lib/api";
import MyExternalInvoices from "../components/MyExternalInvoices";
import EnablePush from "../components/EnablePush";

export default function MyOrders() {
    const [orders, setOrders] = useState([]);
    const [appts, setAppts] = useState([]);

    useEffect(() => {
        api.get("/orders/me").then(r => setOrders(r.data)).catch(() => {});
        api.get("/appointments/me").then(r => setAppts(r.data)).catch(() => {});
    }, []);

    return (
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-testid="my-orders-page">
            <EnablePush variant="card" />
            <section>
                <h2 className="font-serif text-4xl text-stone-900 mb-6">My orders</h2>
                {orders.length === 0 ? <p className="text-sm text-stone-500">No orders yet.</p> : (
                    <div className="space-y-4">
                        {orders.map((o) => (
                            <div key={o.id} className="bg-white border border-stone-200 p-5" data-testid={`order-${o.id}`}>
                                <div className="flex items-center justify-between text-xs text-stone-500 mb-3">
                                    <span>Order #{o.id.slice(0, 8)}</span>
                                    <span className="uppercase tracking-widest">{o.status}</span>
                                </div>
                                <div className="space-y-1 text-sm">
                                    {o.items.map((i, idx) => (
                                        <div key={idx} className="flex justify-between"><span>{i.product_name} ({i.size_label}) × {i.quantity}</span><span>{formatINR(i.price * i.quantity)}</span></div>
                                    ))}
                                </div>
                                <div className="flex justify-between mt-3 pt-3 border-t border-stone-100 font-medium"><span>Total</span><span>{formatINR(o.total)}</span></div>
                            </div>
                        ))}
                    </div>
                )}
            </section>
            <section>
                <h2 className="font-serif text-4xl text-stone-900 mb-6">My appointments</h2>
                {appts.length === 0 ? <p className="text-sm text-stone-500">No appointments yet.</p> : (
                    <div className="space-y-3">
                        {appts.map((a) => (
                            <div key={a.id} className="bg-white border border-stone-200 p-5 flex justify-between items-center" data-testid={`appt-${a.id}`}>
                                <div>
                                    <div className="font-serif text-lg">{a.doctor_name}</div>
                                    <div className="text-xs text-stone-500">{a.mode} · {a.date} at {a.time_slot}</div>
                                </div>
                                <div className="text-right">
                                    <div className="text-xs uppercase tracking-widest text-stone-500">{a.status}</div>
                                    <div className="font-medium text-sky-700">{formatINR(a.fee_total)}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </section>
            <MyExternalInvoices heading="Uploaded invoices" />
        </div>
    );
}
